// extracted by mini-css-extract-plugin
module.exports = {"serverError":"Errors_serverError__2fLYk","notFound":"Errors_notFound__2mD3V","notFoundWithMargin":"Errors_notFoundWithMargin__2Ydry","description":"Errors_description__3pRlz"};